export interface FileData {
  id?: string
  fileName: string
  fileType: string
  fileSize: number
  fileSizeBytes: number
  fileSizeKb: string
  fileSizeMb: string
  base64Content: string
  data: File
  createdAt?: string
  error?: boolean
  errorMessage?: string
}
export const getFileExtensions = () => {
  return [...getImageFileExtensions(), ...getDocumentFileExtensions(), ...getExcelFileExtensions()]
}
export enum ImageFileExtensionType {
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
}

export const getImageFileExtensions = () => {
  return [ImageFileExtensionType.JPG, ImageFileExtensionType.JPEG, ImageFileExtensionType.PNG]
}

export const isImageFileExtensions = (fileType?: string) => {
  if (!fileType) {
    return false
  }
  return getImageFileExtensions()
    .map((x) => x.toString())
    .includes(fileType?.toLowerCase())
}

export enum DocumentFileExtensionType {
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
}

export const getDocumentFileExtensions = () => {
  return [
    DocumentFileExtensionType.PDF,
    DocumentFileExtensionType.DOC,
    DocumentFileExtensionType.DOCX,
  ]
}

export enum ExcelFileExtensionType {
  XLS = 'xls',
  XLSX = 'xlsx',
  CSV = 'csv',
}

export const getExcelFileExtensions = () => {
  return [ExcelFileExtensionType.XLS, ExcelFileExtensionType.XLSX, ExcelFileExtensionType.CSV]
}

export type FileExtension = ImageFileExtension | DocumentExtension | ExcelFileExtension

type ImageFileExtension = 'jpg' | 'jpeg' | 'png'

type DocumentExtension = 'pdf' | 'doc' | 'docx'

type ExcelFileExtension = 'xls' | 'xlsx' | 'csv'
